/*
 * @author: weichuanjia
 * @Date: 2023-07-10 14:07:57
 */
import MenuTemp from '@/components/menu/MenuOne.vue'
export const comMethods = {
  components: {
    MenuTemp
  }
}